export default __webpack_public_path__ + "static/media/VII_Old_White.cbc04400.png";